import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { Trade } from 'ah-api-gateways';
import { formatHedgingInstrument, getBuyCcy, getPrimaryCcy, getSellCcy } from 'ah-api-gateways/models';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { SIMPLE_DATE_FORMAT } from 'ah-common-lib/src/helpers/time';
import { formatDate } from 'ah-common-lib/src/helpers/time';


export default /*#__PURE__*/_defineComponent({
  __name: 'TradeDrawdownInfo',
  props: {
    parentTrade: null,
    drawdown: null
  },
  setup(__props: any) {

const props = __props as {
  parentTrade: Trade;
  drawdown: Trade;
};



const clientRate = computed(() => getPrimaryCcy(props.drawdown).clientRate);

const buyCcy = computed(() => getBuyCcy(props.drawdown).currency);

const sellCcy = computed(() => getSellCcy(props.drawdown).currency);

const buyAmount = computed(() => getBuyCcy(props.drawdown).clientAmount);

const sellAmount = computed(() => getSellCcy(props.drawdown).clientAmount);

const remainingSellAmount = computed(() => {
  const amount = getSellCcy(props.parentTrade).clientAmount - sellAmount.value;
  if (amount <= 0) return 0;
  return amount;
});

const remainingBuyAmount = computed(() => {
  const amount = getBuyCcy(props.parentTrade).clientAmount - buyAmount.value;
  if (amount <= 0) return 0;
  return amount;
});

return { __sfc: true,props, clientRate, buyCcy, sellCcy, buyAmount, sellAmount, remainingSellAmount, remainingBuyAmount, formatHedgingInstrument, formatCurrencyValue, SIMPLE_DATE_FORMAT, formatDate }
}

})